import { hasAnalyticsConsent } from './consent-check.js';

function initVideoTeasers() {
  document.querySelectorAll('.ndg-video-teaser[data-ndg-teaser-src]').forEach( wrap => {
    const btn = wrap.querySelector('.ndg-video-teaser__trigger');
    if ( ! btn ) return;

    btn.addEventListener('click', () => {
      const src = wrap.dataset.ndgTeaserSrc;
      if ( ! src ) return;

      const isThirdParty = src.includes('youtube') || src.includes('player.vimeo.com');

      if ( isThirdParty && ! hasAnalyticsConsent() ) {
        document.querySelector('a[href="#cookiesBanner"]')?.click()
          || document.dispatchEvent(new CustomEvent('ndg:openConsent'));
        return;
      }

      let embed;

      if ( isThirdParty ) {
        embed = document.createElement('iframe');
        embed.src             = src;
        embed.allow           = 'autoplay; fullscreen; picture-in-picture';
        embed.allowFullscreen = true;
      } else {
        embed = document.createElement('video');
        embed.src      = src;
        embed.controls = true;
        embed.autoplay = true;
        embed.setAttribute('playsinline', '');
      }

      embed.className = 'ndg-video-teaser__embed';
      wrap.classList.add('is-playing');
      btn.replaceWith(embed);
    }, { once: true });
  });
}

document.addEventListener('DOMContentLoaded', initVideoTeasers);
